import logo11 from '../asset/logo11.svg';

const CompanyBadge = ({
  label = 'Powered by',
  company = 'Redqubes Innovation pvt.ltd',
  logoAlt = 'RedQubes Logo',
  className = '',
}) => {
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-red-700 via-red-600 to-red-500 px-4 py-2 shadow-md ring-1 ring-red-800/10 ${className}`}
    >
      <span className="text-sm font-medium text-white/90">{label}</span>
      <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-white/15 ring-1 ring-white/20">
        <img loading="lazy" decoding="async" src={logo11} alt={logoAlt} className="h-4 w-4 object-contain" />
      </span>
      <span className="text-sm font-medium text-white">{company}</span>
    </div>
  );
};

export default CompanyBadge;

